import { TabPanel, TabPanelProps } from "@chakra-ui/react";

export interface FilterTabPanelProps extends TabPanelProps {}

export const FilterTabPanel = (props: FilterTabPanelProps) => {
  return <TabPanel p={2} {...props} />;
};
